import React from 'react'
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { DATASET_RULES_FIELD_NAME } from 'app/constants/datasets.constants';
import { QueryViewer } from 'app/views/pages/datasets/components/DatasetRulesBuilder/DatasetRulesBuilder';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tag: {
      flex: 1,
      border: 'solid 1px rgba(0, 0, 0, 0.12)',
      borderRadius: '8px',
    },
  })
)

type Tag = {
  key: string
  value: string
}

interface TagsViewProps {
  tags: Tag[]
  VISUAL_TAGS_LABELS?: { [key: string]: string }
}

export default function TagsView(props: TagsViewProps) {
  const { tags = [], VISUAL_TAGS_LABELS = {} } = props
  const classes = useStyles()
  const parseValue = (tagKey: string, tagValue: string) => {
    if (tagKey === DATASET_RULES_FIELD_NAME) {
      let rules = [];
      try {
        rules = JSON.parse(tagValue) || []
      } catch (error) {
      }

      return <div>
        {rules.map((rule: any, index: number) => {
          return (<div key={"rule-" + index}><strong>{rule.ruleName}:</strong> <QueryViewer value={rule.value} /></div>)
        })}
      </div>
    }
    return Array.isArray(tagValue) ? tagValue.join(', ') : tagValue
  }

  return (
    <div className="flex-column">
      {tags?.length ? (
        tags.map((tag: Tag) => (
          <div
            key={tag.key}
            className={'flex items-center p-2 mb-2 ' + classes.tag}
          >
            <div>
              <span>
                <strong>{VISUAL_TAGS_LABELS[tag.key] || tag.key}:</strong> {parseValue(tag.key, tag.value)}
              </span>
            </div>
          </div>
        ))
      ) : (
        <div className="p-2">No tags found</div>
      )}
    </div>
  )
}
